import React from 'react';
import TextInput from './TextInput';
import { DefaultInputPropTypes } from './types';
import useInputHelper from './inputHelper';
import { useDateService } from '../../utils/hooks/useDateService';

interface DurationBetweenTwoDatesInputProps extends Omit<DefaultInputPropTypes<string>, 'source'> {
  dateFromSource: string;
  dateToSource: string;
  dateFromValue?: string;
  dateToValue?: string;
}

const DurationBetweenTwoDatesInput = ({
  dateFromSource,
  dateFromValue,
  dateToSource,
  dateToValue,
  ...props
}: DurationBetweenTwoDatesInputProps) => {
  const { getValue: getDateFromValue } = useInputHelper({ source: dateFromSource, value: dateFromValue });
  const { getValue: getDateToValue } = useInputHelper({ source: dateToSource, value: dateToValue });
  const { getStringDurationBetweenTwoDates } = useDateService();

  const dateFrom = getDateFromValue();
  const dateTo = getDateToValue();

  const resultValue = getStringDurationBetweenTwoDates(dateFrom, dateTo);

  return <TextInput {...props} source="" disabled value={resultValue} />;
};

export default DurationBetweenTwoDatesInput;
